import React from 'react';
import PropTypes from 'prop-types';
import ExpandableSection from '../../expandableSection';
import { CsatSummaryCards, CsatTable } from './csatSectionParts';

const CsatSection = ({
  expanded,
  onToggle,
  onDownload,
  onMore,
  onMoreMenuItems,
  showMoreAction,
  showActions,
  canEditCsat,
  canDeleteCsat,
  csatOverallTotal,
  csatOverallAverage,
  csatData,
  csatCurrentYearTotal,
  csatCurrentYearAverage,
  csatScore,
  csatDate,
  csatLastReceived,
  getSortClass,
  csatSort,
  getAriaSort,
  handleCsatSort,
  csatTableData,
  projectName,
  resolveCsatCustomerName,
  handleCSATEdit,
  handleCSATDelete,
  isCsatEmpty,
  isLoading,
}) => (
  <ExpandableSection
    title="CSAT"
    expanded={expanded}
    onToggle={onToggle}
    onDownload={onDownload}
    onMore={onMore}
    onMoreMenuItems={onMoreMenuItems}
    showMoreAction={showMoreAction}
    isLoading={isLoading}
  >
    <div className="section-content csat-section">
      <CsatSummaryCards
        csatOverallTotal={csatOverallTotal}
        csatOverallAverage={csatOverallAverage}
        csatData={csatData}
        csatCurrentYearTotal={csatCurrentYearTotal}
        csatCurrentYearAverage={csatCurrentYearAverage}
        csatScore={csatScore}
        csatDate={csatDate}
        csatLastReceived={csatLastReceived}
      />

      <CsatTable
        getSortClass={getSortClass}
        csatSort={csatSort}
        getAriaSort={getAriaSort}
        handleCsatSort={handleCsatSort}
        csatTableData={csatTableData}
        projectName={projectName}
        resolveCsatCustomerName={resolveCsatCustomerName}
        showActions={showActions}
        canEditCsat={canEditCsat}
        canDeleteCsat={canDeleteCsat}
        handleCSATEdit={handleCSATEdit}
        handleCSATDelete={handleCSATDelete}
        isCsatEmpty={isCsatEmpty}
      />
    </div>
  </ExpandableSection>
);

CsatSection.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
  onMore: PropTypes.func,
  onMoreMenuItems: PropTypes.array,
  showMoreAction: PropTypes.bool,
  showActions: PropTypes.bool,
  canEditCsat: PropTypes.bool,
  canDeleteCsat: PropTypes.bool,
  csatOverallTotal: PropTypes.number.isRequired,
  csatOverallAverage: PropTypes.number.isRequired,
  csatData: PropTypes.object.isRequired,
  csatCurrentYearTotal: PropTypes.number.isRequired,
  csatCurrentYearAverage: PropTypes.number.isRequired,
  csatScore: PropTypes.number.isRequired,
  csatDate: PropTypes.string.isRequired,
  csatLastReceived: PropTypes.string.isRequired,
  getSortClass: PropTypes.func.isRequired,
  csatSort: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.string,
  }).isRequired,
  getAriaSort: PropTypes.func.isRequired,
  handleCsatSort: PropTypes.func.isRequired,
  csatTableData: PropTypes.array.isRequired,
  projectName: PropTypes.string,
  resolveCsatCustomerName: PropTypes.func.isRequired,
  handleCSATEdit: PropTypes.func.isRequired,
  handleCSATDelete: PropTypes.func.isRequired,
  isCsatEmpty: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
};

CsatSection.defaultProps = {
  onDownload: null,
  onMore: null,
  onMoreMenuItems: [],
  showMoreAction: true,
  showActions: true,
  canEditCsat: true,
  canDeleteCsat: true,
  projectName: '',
  isLoading: false,
};

export default CsatSection;
